import { FileText, Folder } from "lucide-react";
import { useNavigate } from "@/hooks/useDeskNavigate";
import { LOT_TYPE_ICON, useLotTypes } from "@/components/crm/crmShared";
import { typeLight } from "./SaleRow";

const MONO = { fontFamily: "'JetBrains Mono', Consolas, monospace" };
const CSS = `.sale-docs-list{scrollbar-width:thin;scrollbar-color:#3A3A42 transparent}.sale-docs-list::-webkit-scrollbar{width:4px}.sale-docs-list::-webkit-scrollbar-thumb{background:#3A3A42;border-radius:2px}`;

/** Avancement « a/b » en petits carrés 5 px (même lecture que la liste Documents). */
function Squares({ closed, total }) {
  if (!total) return <span style={{ fontSize: 9.5, color: "#6A6A72" }}>—</span>;
  return (
    <span className="inline-flex items-center shrink-0" style={{ gap: 4 }}>
      <span className="inline-flex" style={{ gap: 2 }}>{Array.from({ length: Math.min(total, 12) }, (_, i) => <i key={i} style={{ display: "block", width: 5, height: 5, borderRadius: 1, background: i < closed ? (closed >= total ? "#22C55E" : "#F97316") : "#2A2A30" }} />)}</span>
      <span className="tabular-nums" style={{ fontSize: 9.5, color: "#8A8A93" }}>{closed}/{total}</span>
    </span>
  );
}

/** iter476 47.2 — bloc « documents liés » de la bande de résumé (310 px) : rail 34 px, une ligne 24 px par document (lots d'abord puis dossier), n° cliquable → Documents. */
export default function SaleDocsBlock({ docs = [], testId }) {
  const navigate = useNavigate();
  const types = useLotTypes();
  if (!docs.length) return null;
  return (
    <div className="flex shrink-0" style={{ width: 310, height: "100%", background: "#141417", border: "1px solid #26262C", borderRadius: 8, overflow: "hidden" }} data-testid={testId}>
      <style>{CSS}</style>
      <div className="flex flex-col items-center shrink-0" style={{ width: 34, background: "#3568B0", paddingTop: 8, gap: 3 }} data-testid={`${testId}-rail`}>
        <FileText size={14} color="#fff" /><span className="tabular-nums" style={{ fontSize: 11, fontWeight: 700, color: "#fff" }} data-testid={`${testId}-count`}>{docs.length}</span>
      </div>
      <div className="sale-docs-list flex flex-col min-w-0" style={{ flex: 1, overflowY: "auto", padding: "4px 6px" }}>
        {docs.map((d) => {
          const def = d.lot ? types.find((x) => x.label === d.lot.type) : null;
          const Icon = d.lot ? (LOT_TYPE_ICON[def?.icon] || LOT_TYPE_ICON.Square) : Folder;
          const where = d.lot ? `${d.lot.type || "Lot"} ${d.lot.numero || ""}${d.lot.block_name ? ` · Bloc ${d.lot.block_name}` : ""}` : "Tout le dossier";
          return (
            <div key={d.id} className="flex items-center shrink-0" style={{ height: 24, gap: 6 }} data-testid={`${testId}-row-${d.id}`}>
              <span className="inline-flex items-center justify-center shrink-0" title={where} style={{ width: 16 }}><Icon size={13} style={{ color: d.lot ? typeLight(d.lot.type) : "#6A6A72" }} /></span>
              <button type="button" onClick={() => navigate(`/documents/${d.id}`)} className="shrink-0" title={`Ouvrir ${d.reference || "le document"} dans Documents`} style={{ ...MONO, fontSize: 11, fontWeight: 700, color: "#93C5FD", textDecoration: "underline", textDecorationColor: "#1E3A8A", textUnderlineOffset: 2, background: "transparent", padding: 0 }} data-testid={`${testId}-open-${d.id}`}>{d.reference || "—"}</button>
              <span className="truncate" title={d.type || d.title} style={{ flex: 1, fontSize: 10.5, color: "#C9C9CF" }}>{d.type || d.title}</span>
              <Squares closed={d.closed} total={d.total} />
            </div>);
        })}
      </div>
    </div>
  );
}
